<template>
  <v-row class="small-avatar-row">
    <v-col style="padding-right: 0;">
      <div :style="styleUserRow()">
        <v-avatar
          :size="avatarSize"
          v-for="(user, index) in users.slice(0, 5)"
          :key="'user-'+index"
          :style="styleUser(user.uid, index)"
        >
          <img
            :src="avatar(user.photo)"
            :alt="currentUser.uid + '-' + user.bio"
          />
        </v-avatar>
      </div>
      <div :style="'line-height: ' + avatarSize + 'px'">
        <span class="prognostic-number" v-if="users.length > 5">+{{users.length - 5}} Prognósticos</span>
        <span class="prognostic-number" v-else>{{users.length}} Prognósticos</span>
      </div>
    </v-col>
  </v-row>
</template>

<style scoped>
.small-avatar-row {
  position: relative;
}
.small-avatar-row .v-avatar {
  border: 1px solid #26ab5e;
  position: absolute;
}
.small-avatar-row .v-avatar:nth-child(2) {
  left: 24px;
}
.small-avatar-row .v-avatar:nth-child(3) {
  left: 36px;
}
.small-avatar-row .v-avatar:nth-child(4) {
  left: 48px;
}
.small-avatar-row .v-avatar:nth-child(5) {
  left: 60px;
}
.prognostic-number {
  font-family: Gilroy-Bold;
  font-size: 11px;
  line-height: 16px;
  color: #bcc5cc;
}
.transparent {
  color:transparent
}
</style>

<script>
import Vue from "vue";

export default Vue.extend({
  name: "UserAvatarList",
  props: {
    users: {},
    avatarSize: Number,
    avatarOverlay: Number
  },
  data: () => ({}),
  methods: {
    styleUser(uid, index) {
      const position = 12 + (this.avatarSize * index * this.avatarOverlay);
      return {
        "border-color":
          uid == this.$store.state.user.uid ? "#FFC121" : "#26ab5e",
        left: `${position}px`
      };
    },
    styleUserRow() {
      const usersLength = this.users.slice(0, 5).length
      // if 0 then just use left margin (12px), else if 1 then use left margin plus avatar size plus margin right, else do calculations
      //const width = usersLength == 0 ? 12 : usersLength == 1 ? 12 + this.avatarSize + 8 : 12 + (this.avatarSize * (this.avatarOverlay + this.avatarOverlay * (usersLength))); 40 + (40 * 0.75 * 4)
      const width = usersLength == 0 ? 12 : usersLength == 1 ? 12 + this.avatarSize + 8 : 12 + (this.avatarSize + (this.avatarSize * this.avatarOverlay * (usersLength - 1))) + 8;
      return {
        height: `${this.avatarSize}px`,
        width: `${width}px`,
        float: "left"
      };
    },
    stylePrognosticsRow() {
      const width = 12 + (this.avatarSize * this.users.slice(0, 5).length) / 2;
      return {
        height: `${this.avatarSize}px`,
        width: `${width}px`
      };
    },
    avatar(photo) {
      if(photo) {
        return photo;
      } else {
        return require("../assets/images/avatar.png");
      }      
    },
  },
  computed: {
    currentUser() {
      return this.$store.state.user;
    },
    
  }
});
</script>
<!-- v-bind:style="currentUser.uid == user.uid ? 'border-color: #FFC121;' : ''" -->